/**
 * Copyright © 2018, JDA Software Group, Inc. ALL RIGHTS RESERVED.
 * <p>
 * This software is the confidential information of JDA Software, Inc., and is licensed
 * as restricted rights software. The use,reproduction, or disclosure of this software
 * is subject to restrictions set forth in your license agreement with JDA.
 */
/**
 * Defines the abstract client
 */
import EventEmitter from 'events';

class MyEmitter {
  eventEmitter: EventEmitter;
  /**
   * Initiate the event emitter
   */
  constructor() {
    this.eventEmitter = new EventEmitter();
  }

  /**
   * Adds the @listener function to the end of the listeners array
   * for the event named @eventName
   * Will ensure that only one time the listener added for the event
   *
   * @param {string} eventName
   * @param {function} listener
   */
  on(eventName: string | symbol, listener: (...args: any[]) => void) {
    this.eventEmitter.on(eventName, listener);
  }

  /**
   * Will temove the specified @listener from @eventname list
   *
   * @param {string} eventName
   * @param {function} listener
   */
  removeEventListener(eventName: string | symbol, listener: (...args: any[]) => void) {
    this.eventEmitter.removeListener(eventName, listener);
  }

  /**
   * Will emit the event on the event name with the @payload
   * and if its an error set the @error value
   *
   * @param {string} event
   * @param {object} payload
   * @param {boolean} error
   */
  emit(event: string | symbol, ...payload: any[]) {
    this.eventEmitter.emit(event, payload);
  }

  /**
   * Returns the event emitter
   * Used for testing purpose and avoid using this during development
   */
  getEventEmitter() {
    return this.eventEmitter;
  }

  setMaxListeners(value: number) {
    this.eventEmitter.setMaxListeners(value);
  }
}

const client = new MyEmitter();
export default client;
